import { ShareIcon } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Upload = styled(ShareIcon)`
  width: 100px;
  height: 100px;
  color: ${({ theme }) => theme.palette.common.white};
`;
